define('AACertified.LandingPage.View'
,	[
		'aacertified_landingpage.tpl'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	,	'Utils'
	]
,	function (
		aacertified_landingpage_tpl
	,	Backbone
	,	jQuery
	,	_
	,	Utils
	)
{
	'use strict';

	return Backbone.View.extend({

		template: aacertified_landingpage_tpl

	,	title: Utils.translate('AA Certified')

	,	page_header: Utils.translate('AA Certified')

	,	attributes: {
			id: 'aa-certified-lp'
		}

	,	events: {
			'click [data-action="toggle-condition-tab"]': 'onConditionTabToggle'
		}

	,	initialize: function (options) {
			this.options = options;
			this.application = options.application;

			jQuery(document).on('contextmenu.aacertified', function (e) {
				e.preventDefault();
				return false;
			});
		}

	,	destroy: function () {
			jQuery(document).off('contextmenu.aacertified');
			Backbone.View.prototype.destroy.apply(this, arguments);
		}

	,	getBreadcrumbPages: function () {
			return [
				{ text: Utils.translate('AA Certified'), href: '/aa-certified' }
			];
		}

	,	onConditionTabToggle: function (e) {
			e.preventDefault();
			var $btn = jQuery(e.currentTarget);
			var tab = $btn.data('tab');

			this.$('[data-action="toggle-condition-tab"]').removeClass('active');
			$btn.addClass('active');

			this.$('[data-condition-content]').hide();
			this.$('[data-condition-content="' + tab + '"]').show();
		}

	,	getContext: function () {
			return {};
		}
	});
});
